import { render } from "./NewsletterSubscribers.vue?vue&type=template&id=18efa542&scoped=true"
import script from "./NewsletterSubscribers.vue?vue&type=script&lang=js"
export * from "./NewsletterSubscribers.vue?vue&type=script&lang=js"

import "./NewsletterSubscribers.vue?vue&type=style&index=0&id=18efa542&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18efa542"]])

export default __exports__